import { createApiQuery } from '@/hooks/use-api-query';
import { get } from "@/libs/http";
import { FantasyReq, FantasyRes } from "@/types/api/hall/fantasy";


export const getFantasyList = (params: FantasyReq) => get<FantasyRes>('/hall/v1/fantasy', { params });

export const useFantasyList = createApiQuery(getFantasyList, (params: FantasyReq) => ['fantasyList', params]);
